import { useFormik } from "formik";
import * as Yup from "yup";
import { FaGoogle } from "react-icons/fa";
import { Link, useNavigate, useParams } from "react-router-dom";
import { handleSocialLogin } from "./SocialProvider";
import { googleProvider } from "../../firebase";
import { axiosConfig } from "../../api/axiosClient";
import { useState } from "react";
import { toast } from "react-toastify";
import InputField from "../../components/form/InputField";
import logo200 from "../../assets/logo/logo-200.png";

const LoginPage = () => {
  const navigate = useNavigate();
  const { callback } = useParams(); // récupère callback dynamique depuis l'URL
  const [loading, setLoading] = useState(false);
  const [socialRegister, setSocialRegister] = useState(false);

  const formik = useFormik({
    initialValues: {
      identifiant: "",
      password: "",
    },
    validationSchema: Yup.object({
      identifiant: Yup.string()
        // .email("Email invalide")
        .required("Identifiant requis"),
      password: Yup.string().required("Mot de passe requis"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      // console.log("Values récupérées: ", values)
      // Appel API pour la connexion
      try {
        const response = await axiosConfig.post("/auth/login/", values); // endpoint à adapter
        console.log("Réponse API :", response);

        console.log("response data: ", response.data);
        const authToken = response.data.token;

        localStorage.setItem("authToken", authToken);

        toast.success("Bienvenue!", { position: "top-center" });

        // Redirection ou autre action après connexion réussie
        if (response.data.role === "client") {
          navigate("/index");
        } else {
          navigate("/admin/dashboard");
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.error ||
            "Erreur lors de la connexion. Veuillez vérifier vos identifiants.",
        );

        if (socialRegister) {
          formik.setFieldValue("password", "");
        }

        // console.error("Réponse API :", error?.response?.status);
        if (error?.response?.status) {
          const status = error.response.status;
          if (status === 475) {
            // toast.error("Compte non activé. Veuillez vérifier votre e-mail pour l'activation.", {
            //     position: "bottom-left"
            // });

            // Compte non activé
            navigate(`/account-not-activated/${callback || ""}`, {
              state: {
                email: values.identifiant,
              },
            });
            setLoading(false);

            return;
          }
        }
        console.error("Erreur lors de la connexion :", error);
        setLoading(false);

        // Gestion des erreurs (affichage message, etc.)
      }
    },
  });

  const handleGoogleLogin = async () => {
    setLoading(true);
    try {
      const dataGoogle = await handleSocialLogin(googleProvider);
      setSocialRegister(true);

      const uid = dataGoogle?.uid || "";
      const email = dataGoogle?.providerData?.[0]?.email || "";

      formik.setFieldValue("password", `${uid}@gmail.com`);
      formik.setFieldValue("identifiant", email);

      setTimeout(() => {
        formik.handleSubmit();
      }, 500);
    } catch (error) {
      console.error("Erreur de connexion Google :", error);
      // Optionnel : afficher un toast ou message d'erreur
      formik.setFieldValue("password", "");
      toast.error(
        error?.response?.data?.error || "Erreur de connexion Google.",
      );
    }
    setLoading(false);
  };

  document.title = "Connexion || Barberlys";

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-xl bg-white shadow-xl p-8">
        {/* Header */}
        <div className="mb-6 text-center">
          {/* <span className="text-sm bg-secondary-50 text-secondary-700 px-3 py-1 font-medium">
            Connexion
          </span> */}
          <Link to={`/index`} className="cursor-pointer">
            <img src={logo200} alt="logo" className="m-auto" />
          </Link>
          {/* <h2 className="text-2xl font-semibold mt-3">Bienvenue</h2> */}
        </div>

        {/* Social Buttons */}
        <div className="flex justify-center gap-4 mb-6">
          <button
            type="button"
            onClick={handleGoogleLogin}
            className="bg-[#1a73e8] text-white p-3 hover:scale-105 transition flex gap-2 items-center"
          >
            <FaGoogle size={20} />
            <span>Connexion avec Google</span>
          </button>
        </div>

        {/* Form */}
        <form className="space-y-5" onSubmit={formik.handleSubmit}>
          <InputField
            formik={formik}
            type="identifiant"
            name="identifiant"
            placeholder="Identifiant"
            className="w-full placeholder-gray-400 px-4 py-2 shadow focus:outline-none focus:ring-2 focus:ring-gray-500"
          />

          <div className="space-y-1">
            <InputField
              formik={formik}
              type="password"
              name="password"
              placeholder="Mot de passe"
              className="w-full placeholder-gray-400 px-4 py-2 shadow focus:outline-none focus:ring-2 focus:ring-gray-500"
            />
            <p className="text-end text-sm text-gray-300 ">
              <Link
                to="/forgot-password"
                className="text-secondary-500 hover:text-secondary-800"
              >
                Mot de passe oublié ?
              </Link>
            </p>
          </div>

          <button
            disabled={!(formik.isValid && formik.dirty) || loading}
            type="submit"
            className={`w-full bg-secondary-300 ${
              !(formik.isValid && formik.dirty) ? "" : " hover:bg-secondary-500"
            } text-white py-2 font-semibold transition-all`}
          >
            {loading ? (
              <div className="flex flex-row justify-center items-center gap-2">
                <div className="animate-spin rounded-full h-4 w-4 border-t-4 border-b-4 border-white" />
                <span>Connexion...</span>
              </div>
            ) : (
              "Se connecter"
            )}
          </button>

          <p className="text-center text-sm mt-4">
            Pas encore de compte ?{" "}
            <Link
              to={`/register`}
              // to="/register"
              className="text-secondary-500 hover:text-secondary-800"
            >
              S'inscrire
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
